var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        title:
          _vm.drawRow.type === "add"
            ? _vm.$t("system::team::添加员工")
            : _vm.$t("system::team::编辑员工"),
        visible: _vm.dialogVisible,
        "destroy-on-close": "",
        width: "500px",
      },
      on: {
        close: _vm.onChange,
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "staffForm",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "keyword",
                label: _vm.$t("system::team::account"),
              },
            },
            [
              _c("el-input", {
                staticClass: "input-item",
                attrs: {
                  disabled: _vm.drawRow.type === "edit",
                  placeholder: _vm.$t("system::team::placeholdere_info"),
                },
                model: {
                  value: _vm.form.keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "keyword", $$v)
                  },
                  expression: "form.keyword",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "teamId", label: _vm.$t("system::team::team") } },
            [
              _c("el-cascader", {
                staticClass: "input-item",
                attrs: {
                  placeholder: _vm.$t("system::team::placeholdere_team"),
                  options: _vm.teamDataList,
                  props: {
                    checkStrictly: false,
                    value: "id",
                    label: "name",
                    children: "children",
                  },
                  clearable: "",
                },
                model: {
                  value: _vm.form.teamId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "teamId", $$v)
                  },
                  expression: "form.teamId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "roleId", label: _vm.$t("system::team::role") } },
            [
              _vm.defaultRoleList.length
                ? _c(
                    "el-select",
                    {
                      staticClass: "input-item",
                      attrs: {
                        "remote-method": _vm.remoteMethod,
                        filterable: "",
                        multiple: "",
                        remote: "",
                        loading: _vm.vloading,
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.form.roleId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "roleId", $$v)
                        },
                        expression: "form.roleId",
                      },
                    },
                    _vm._l(_vm.roleList, function (item) {
                      return _c("el-option", {
                        key: item.roleId,
                        attrs: {
                          placeholder: _vm.$t(
                            "system::team::placeholdere_role"
                          ),
                          label: item.roleName,
                          value: item.roleId,
                        },
                      })
                    }),
                    1
                  )
                : _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("system::team::placeholdere_role_to")) +
                        " "
                    ),
                    _c("a", { on: { click: _vm.toLink } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("system::team::placeholdere_role_to_link")
                        )
                      ),
                    ]),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "footer_class",
          staticStyle: { "text-align": "center", display: "block" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onChange } }, [
            _vm._v(_vm._s(_vm.$t("system::common::btn::cancel"))),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.sumbit } },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }